import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

import { createStore, combineReducers, applyMiddleware } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { createFirestoreInstance, firestoreReducer } from 'redux-firestore';
import collections from './constants/FirestoreCollections';
import { reducer } from './reducers';

const fbConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// react-redux-firebase config
const rrfConfig = {
  userProfile: collections.users,
  useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
  enableClaims: true, // Get custom claims along with the profile
};

// Initialize firebase instance
firebase.initializeApp(fbConfig);

// add if you want to use firestore emulator
// firebase.firestore().settings({
//   host: 'localhost:8080',
//   ssl: false,
// });

// Initialize other services on firebase instance
firebase.firestore();
firebase.functions();
// firebase.functions().useFunctionsEmulator('http://localhost:5001');

// Add firebase to reducers
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  app: reducer,
});

// Middleware para ver el objeto de profile antes de guardarlo en el estado de Redux
const profileLogger =
  (store: any) =>
  (next: (arg0: { type: string; profile: any }) => any) =>
  (action: { type: string; profile: any }) => {
    if (action.type === '@@reactReduxFirebase/SET_PROFILE') {
      const modifiedProfile = { ...action.profile, supportedChats: [] };
      action.profile = modifiedProfile;
    }
    return next(action);
  };
// Create store with reducers and initial state
const initialState = {};
export const store = createStore(rootReducer, initialState, applyMiddleware(profileLogger));

export const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};
